/**
 * Support form navigation: hash scroll, sticky-header offset, category preselect.
 */
(function () {
  "use strict";

  var FORM_TARGETS = ["pma-support-ticket-form", "pma-support-contact-form"];
  var HEADER_OFFSET = 96;

  function getHashTarget() {
    var hash = (window.location.hash || "").replace(/^#/, "");
    return FORM_TARGETS.indexOf(hash) !== -1 ? hash : "";
  }

  function scrollToTarget(id, focus) {
    if (!id) return false;
    var el = document.getElementById(id);
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    if (focus) {
      window.setTimeout(function () {
        el.setAttribute("tabindex", "-1");
        el.focus({ preventScroll: true });
      }, 350);
    }
    return true;
  }

  function applyCategoryPreset() {
    var params = new URLSearchParams(window.location.search);
    var preset = params.get("support_category");
    if (!preset) return;
    var section = document.querySelector('[data-section-handle="pma__support_ticket_form"]');
    if (!section) return;
    var allowed = (section.getAttribute("data-allowed-categories") || "").split(",").filter(Boolean);
    if (allowed.indexOf(preset) === -1) return;
    var select = section.querySelector("[data-support-category]");
    if (select) select.value = preset;
  }

  function onReady() {
    applyCategoryPreset();
    var target = getHashTarget();
    if (target) scrollToTarget(target, true);
  }

  document.addEventListener("click", function (event) {
    var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;
    if (!link) return;
    var href = link.getAttribute("href") || "";
    var hashIndex = href.indexOf("#");
    if (hashIndex === -1) return;
    var hash = href.slice(hashIndex + 1);
    if (FORM_TARGETS.indexOf(hash) === -1) return;
    var pathPart = href.slice(0, hashIndex) || window.location.pathname;
    var samePage =
      pathPart === "" ||
      pathPart === window.location.pathname ||
      pathPart === window.location.pathname + window.location.search;
    if (!samePage) return;
    event.preventDefault();
    try {
      var url = window.location.pathname + window.location.search + "#" + hash;
      window.history.replaceState(null, "", url);
    } catch (_e) {
      window.location.hash = hash;
    }
    scrollToTarget(hash, true);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
  window.addEventListener("hashchange", function () {
    var target = getHashTarget();
    if (target) scrollToTarget(target, true);
  });
})();
